import Loadable from 'react-loadable';

export const ProjectEmbed = Loadable({
  loader: () => import(/* webpackChunkName: "ProjectEmbed" */ './components/Project/ProjectEmbed'),
  loading: () => null,
});

export const GoalEmbed = Loadable({
  loader: () => import(/* webpackChunkName: "GoalEmbed" */ './components/Goal/GoalEmbed'),
  loading: () => null,
});

export const ProjectsDirectoryEmbed = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ProjectsDirectoryEmbed" */ './components/ProjectsDirectory/ProjectsDirectoryEmbed'),
  loading: () => null,
});

export const GoalsDirectoryEmbed = Loadable({
  loader: () => import(/* webpackChunkName: "GoalsDirectoryEmbed" */ './components/GoalsDirectory/GoalsDirectoryEmbed'),
  loading: () => null,
});

export { goalEmbedResource } from './resources/goalEmbedResource';
export { goalsDirectoryEmbedResource } from './resources/goalsDirectoryEmbedResource';
export { projectEmbedResource } from './resources/projectEmbedResource';
export { projectsDirectoryEmbedResource } from './resources/projectsDirectoryEmbedResource';
export { labelEmbedResource } from './resources/labelResource';
export { EMBED_ROUTE_NAMES } from './util';
export {
  projectsDirectoryEmbedRoute,
  goalsDirectoryEmbedRoute,
  labelEmbedRoute,
  goalEmbedRoute,
  projectEmbedRoute,
  createKudosEmbedRoute,
  createKudosEmbedRouteOld,
} from './routes';
